// src/components/FaunaRace/FaunaRaceGame.js
import React, { useReducer } from 'react';
import { faunaData } from '../../gameLogics/faunaRaceData';
import Footer from '../Footer'; 

// Impor semua komponen layar
import FaunaHomeScreen from './FaunaHomeScreen';
import FaunaModeScreen from './FaunaModeScreen';
import FaunaDifficultyScreen from './FaunaDifficultyScreen';
import FaunaGameplayScreen from './FaunaGameplayScreen';
import FaunaBackground from './FaunaBackground';

// --- Konstanta untuk Aksi & Nilai ---
const ACTIONS = {
    SELECT_MODE: 'select-mode',
    SELECT_DIFFICULTY: 'select-difficulty',
    SUBMIT_ANSWER: 'submit-answer',
    NEXT_QUESTION: 'next-question',
    PLAY_AGAIN: 'play-again',
    GO_TO_SCREEN: 'go-to-screen',
};

// PERBAIKAN: Definisikan semua aturan skor sebagai konstanta
const WINNING_SCORE = 100;
const SCORE_INCREMENT = 10;     // Poin untuk jawaban benar
const SCORE_PENALTY = 5;        // Poin yang dikurangi untuk jawaban salah
const OPPONENT_PENALTY = 2;     // Poin yang dikurangi dari lawan jika kita benar

// --- Fungsi Reducer untuk Mengelola Semua State ---
function reducer(state, action) {
    switch (action.type) {
        case ACTIONS.GO_TO_SCREEN:
            return { ...state, screen: action.payload.screen };
        
        case ACTIONS.SELECT_MODE:
            return { ...state, screen: 'difficulty', mode: action.payload.mode };

        case ACTIONS.SELECT_DIFFICULTY:
            const pool = [...faunaData[state.mode][action.payload.difficulty]].sort(() => Math.random() - 0.5);
            return {
                ...state,
                screen: 'game',
                difficulty: action.payload.difficulty,
                questions: pool,
                questionIndex: 0,
            };
        
        // ==========================================================
        // PERBAIKAN UTAMA: Implementasi logika skor baru di sini
        // ==========================================================
        case ACTIONS.SUBMIT_ANSWER: { // Menggunakan kurung kurawal untuk scope variabel lokal
            const { team, answer } = action.payload;
            const currentQuestion = state.questions[state.questionIndex];
            const isCorrect = answer === currentQuestion.answer;
            
            // Inisialisasi skor baru dari state saat ini
            let newGreenScore = state.greenScore;
            let newRedScore = state.redScore;
            
            if (isCorrect) {
                // Jika jawaban benar
                if (team === 'green') {
                    newGreenScore = Math.min(WINNING_SCORE, state.greenScore + SCORE_INCREMENT);
                    newRedScore = Math.max(0, state.redScore - OPPONENT_PENALTY); // Serang lawan!
                } else { // team === 'red'
                    newRedScore = Math.min(WINNING_SCORE, state.redScore + SCORE_INCREMENT);
                    newGreenScore = Math.max(0, state.greenScore - OPPONENT_PENALTY); // Serang lawan!
                }
            } else {
                // Jika jawaban salah, kurangi skor tim yang menjawab
                if (team === 'green') {
                    newGreenScore = Math.max(0, state.greenScore - SCORE_PENALTY);
                } else { // team === 'red'
                    newRedScore = Math.max(0, state.redScore - SCORE_PENALTY);
                }
            }

            return {
                ...state,
                greenScore: newGreenScore,
                redScore: newRedScore,
                feedback: { team, isCorrect },
                // Cek pemenang setelah setiap jawaban
                winner: (newGreenScore >= WINNING_SCORE) ? 'green' : (newRedScore >= WINNING_SCORE) ? 'red' : null,
            };
        }

        case ACTIONS.NEXT_QUESTION:
            const nextIndex = state.questionIndex + 1;
            if (nextIndex >= state.questions.length) {
                // Jika soal habis, tentukan pemenang dari skor tertinggi
                return { 
                    ...state, 
                    feedback: null,
                    winner: state.greenScore > state.redScore ? 'green' : state.redScore > state.greenScore ? 'red' : 'tie',
                };
            }
            return { ...state, questionIndex: nextIndex, feedback: null };

        case ACTIONS.PLAY_AGAIN:
            // Reset semua state permainan, tapi langsung ke pemilihan mode
            return {
                ...initialState, // initialState didefinisikan di bawah
                screen: 'mode',
            };
        
        default:
            return state;
    }
}

const initialState = {
    screen: 'home',
    mode: null,
    difficulty: null,
    questions: [],
    questionIndex: 0,
    greenScore: 0,
    redScore: 0,
    winner: null,
    feedback: null,
};

function FaunaRaceGame({ onGoHome }) {
    const [state, dispatch] = useReducer(reducer, initialState);

    const renderScreen = () => {
        switch (state.screen) {
            case 'mode':
                return <FaunaModeScreen dispatch={dispatch} />;
            case 'difficulty':
                return <FaunaDifficultyScreen dispatch={dispatch} />;
            case 'game':
                return <FaunaGameplayScreen state={state} dispatch={dispatch} />;
            case 'home':
            default:
                return <FaunaHomeScreen dispatch={dispatch} onGoHome={onGoHome} />;
        }
    };


    return (
        <div style={{ width: '100%', height: '100%', position: 'relative' }}>
            <FaunaBackground />
            {renderScreen()}
            <Footer darkTheme={true} />
        </div>
    );
}

export { ACTIONS };
export default FaunaRaceGame;